import AddIcon from "@mui/icons-material/Add";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import TicketTable from "../Components/Tickets/TicketTable";
import { useState } from "react";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import DateRangePicker from "../Components/DateRangePicker/DateRangePicker";
import CancelIcon from "@mui/icons-material/Cancel";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Box from "@mui/material/Box";
import TicketDialogBox from "../Components/Tickets/TicketDialogBox";
import { EDialogAction } from "../Components/Enum/DialogActionEnum";
import { SearchOutlined } from "@mui/icons-material";
import { Button, Card } from "@mui/material";
import Scaffold from "../Components/Layout/Scaffold";

const Tickets = () => {
  let [hide, setHide] = useState(true);

  let [filter, setfilter] = useState<any>({});
  const [editDialogVisibility, setEditDialogVisibility] = useState(false);
  const [textInput, setTextInput] = useState("");

  const handleTextInputChange = (event: any) => {
    setTextInput(event.target.value);
  };

  function hideDiv() {
    if (hide == true) {
      setHide(false);
    } else {
      setHide(true);
    }
  }

  function changeFilters(key: string, value: string) {
    setfilter((oldState: any) => {
      return { ...oldState, [key]: value };
    });
  }

  function clearData() {
    setfilter({});
  }
  function clearSearch() {
    setTextInput("");
    changeFilters("keyword", "");
  }

  function editDialogClose() {
    setEditDialogVisibility(false);
    changeFilters("timestamp", "" + Date.now());
  }

  return (
    <Scaffold
      title="Tickets"
      mainAction={<Button variant="contained"
        color="primary"
        onClick={() => {
          setEditDialogVisibility(true);
        }}
        startIcon={<AddIcon fontSize="small" />}
      >
        Create
      </Button>}
      actions={[
        <Box
          component="form"
          sx={{
            "& .MuiTextField-root": {
              maxWidth: "75ch",
            },
          }}
          noValidate
          autoComplete="off"
        >
          <TextField
            id="outlined-search"
            type="search"
            label="Search"
            variant="outlined"
            inputProps={{
              style: {
                width: "300px",
                fontSize: "14px",
              },
            }}
            size="small"
            placeholder="Enter search keyword"
            value={textInput}
            onChange={handleTextInputChange}
          />
          <Button
            endIcon={<SearchOutlined />}
            className="mx-2"
            variant="contained"
            color="secondary"
            onClick={() => {
              changeFilters("keyword", "" + textInput);
            }}>
            Search
          </Button>
          <Button
            variant={hide ? "outlined" : "contained"}
            color="secondary"
            onClick={hideDiv}
            startIcon={<FilterAltIcon fontSize="small" />}
          >
            {hide ? "Show" : "Hide"} Filters
          </Button>
        </Box >
      ]}
      secondaryAction={<>

        {!hide && (
          <Card className="flex w-full space-x-4 px-2 py-3 border " elevation={0}>
            <div className="flex  ">
              <FormControl size="small" sx={{ minWidth: 120 }}>
                <InputLabel
                  id="select-standard-label"
                  className="text-sm"
                >
                  Ticket Status
                </InputLabel>
                <Select
                  style={{
                    width: 200,
                  }}
                  labelId="select-standard-label"
                  id="demo-simple-select-standard"
                  value={filter.status || ""}
                  onChange={(event) => {
                    changeFilters("status", event.target.value);
                    if (event.target.value == "") {
                      clearData();
                    }
                  }}
                  label="Ticket Status"

                >
                  <MenuItem value="">
                    <em>None</em>
                  </MenuItem>
                  <MenuItem value={"p"}>Processing</MenuItem>
                  <MenuItem value={"c"}>Completed</MenuItem>
                </Select>
              </FormControl>

            </div>

            <Button
              variant="contained"
              color="secondary"
              size="small"
              endIcon={<SearchOutlined />}
              onClick={() => {
                changeFilters("timestamp", "" + Date.now());
              }}
            >
              Search
            </Button>
            <Button className="mt-1" color="error" variant="text" onClick={clearData}>
              <CancelIcon />
            </Button>
          </Card>
        ) }
      </>}
    >
      <div>
        <TicketTable filter={filter} />
        <TicketDialogBox
          open={editDialogVisibility}
          onClose={editDialogClose}
          data={{}}
          dialogAction={EDialogAction.create}
        />
      </div>
    </Scaffold >
  )


  // old code is below
  return (
    <>
      <p className="text-2xl mb-3 ">Tickets</p>
      <div className="flex flex-col md:flex-row">
        <div className="flex">
          <Box
            component="form"
            sx={{
              "& .MuiTextField-root": {
                maxWidth: "75ch",
              },
            }}
            noValidate
            autoComplete="off"
          >
            <div>
              <TextField
                id="outlined-search"
                type="search"
                label="Search"
                variant="outlined"
                inputProps={{
                  style: {
                    width: "300px",
                    fontSize: "14px",
                  },
                }}
                size="small"
                placeholder="Enter search keyword"
                value={textInput}
                onChange={handleTextInputChange}
              />
            </div>
          </Box>

          <Button
            endIcon={<SearchOutlined />}
            className="mx-2"
            variant="contained"
            color="secondary"
            size="small"
            onClick={() => {
              changeFilters("keyword", "" + textInput);
            }}>
            Search
          </Button>
        </div>
        <div className="flex md:w-full md:justify-end ">
          <Button variant="contained"
            color="primary"
            onClick={() => {
              setEditDialogVisibility(true);
              console.log(editDialogVisibility);
            }}
            startIcon={<AddIcon fontSize="small" />}
          >
            Create
          </Button>

        </div>
      </div>
      <div className="flex space-x-2 mt-6 md:mt-4 ">
        <Button
          variant={hide ? "outlined" : "contained"}
          color="secondary"
          size="small"
          onClick={hideDiv}
          startIcon={<FilterAltIcon fontSize="small" />}
        >
          {hide ? "More" : "Hide"} Filters
        </Button>
      </div>
      {!hide ? (
        <Card className="flex w-full mt-2 space-x-4 px-2 py-3 ">
          {/* <div className="flex ">
              <DateRangePicker />
            </div> */}

          <div className="flex  ">
            <FormControl size="small" sx={{ minWidth: 120 }}>
              <InputLabel
                id="select-standard-label"
                className="text-sm"
              >
                Ticket Status
              </InputLabel>
              <Select
                style={{
                  width: 200,
                }}
                labelId="select-standard-label"
                id="demo-simple-select-standard"
                value={filter.status || ""}
                onChange={(event) => {
                  changeFilters("status", event.target.value);
                  if (event.target.value == "") {
                    clearData();
                  }
                }}
                label="Ticket Status"

              >
                <MenuItem value="">
                  <em>None</em>
                </MenuItem>
                <MenuItem value={"p"}>Processing</MenuItem>
                <MenuItem value={"c"}>Completed</MenuItem>
              </Select>
            </FormControl>

          </div>

          <Button
            variant="contained"
            color="secondary"
            size="small"
            endIcon={<SearchOutlined />}
            onClick={() => {
              changeFilters("timestamp", "" + Date.now());
            }}
          >
            Search
          </Button>
          <Button className="mt-1" color="error" variant="text" onClick={clearData}>
            <CancelIcon />
          </Button>
        </Card>
      ) : (
        <div></div>
      )}
      <div>
        <TicketTable filter={filter} />
      </div>
      <div>
        <TicketDialogBox
          open={editDialogVisibility}
          onClose={editDialogClose}
          data={{}}
          dialogAction={EDialogAction.create}
        />
      </div>
    </>
  );
};

export default Tickets;
